/** Espelha `FadigaRules` do servidor. A barra interpola entre os frames. */
export const FADIGA_TETO = 1440;
/** Acima de 100% com o Pergaminho de Fadiga (techspec-pergaminhos-loja): o limite do smallint do banco. */
export const FADIGA_MAXIMO = 32767;
export const FADIGA_AMBAR = 144;
export const FADIGA_ESGOTADO = 11;
export const FADIGA_CUSTO_DECIMO = 12;

export const FADIGA_REPOUSO = 0;
export const FADIGA_VIGILIA = 1;
export const FADIGA_TREINO = 2;
/** Coletando: gasta 3/min (1.440 duram 8 h). Espelha `FadigaRules.Coleta`. */
export const FADIGA_COLETA = 3;
export const FADIGA_COLETA_POR_MIN = FADIGA_TETO / (8 * 60);
/** Caçando: gasta como a coleta (3/min, 100% em 8 h). Esgotada, a caçada segue sem saque e sem skill. */
export const FADIGA_CACADA = 4;

export type FadigaTom = 'fadiga' | 'fadiga-ambar' | 'fadiga-esgotado';

export function tomFadiga(value: number): FadigaTom {
  if (value <= FADIGA_ESGOTADO) return 'fadiga-esgotado';
  if (value <= FADIGA_AMBAR) return 'fadiga-ambar';
  return 'fadiga';
}

export function taxaFadiga(faixa: number): number {
  if (faixa === FADIGA_COLETA || faixa === FADIGA_CACADA) return -FADIGA_COLETA_POR_MIN;
  // Do 0 aos 100%: manequim 8 h, online 10 h, desconectado 14 h (espelha FadigaRules).
  if (faixa === FADIGA_TREINO) return FADIGA_TETO / (8 * 60);
  if (faixa === FADIGA_VIGILIA) return FADIGA_TETO / (10 * 60);
  return FADIGA_TETO / (14 * 60);
}

/** Pontos de skill que o tanque permite num dia, na faixa dada. Espelha FadigaRules. */
export function pontosPorDia(faixa: number): number {
  return (taxaFadiga(faixa) * FADIGA_TETO) / (FADIGA_CUSTO_DECIMO * 10);
}

export function fadigaAgora(
  snap: number,
  emMs: number,
  faixa: number,
  agoraMs: number
): number {
  const min = (agoraMs - emMs) / 60_000;
  if (!(emMs > 0) || min <= 0) return clamp(snap, 0, FADIGA_MAXIMO);
  const taxa = taxaFadiga(faixa);
  // Acima de 100% (pergaminho), o descanso não mexe; a caçada e a coleta gastam do valor acima (espelha FadigaRules).
  if (taxa >= 0 && snap >= FADIGA_TETO) return Math.min(snap, FADIGA_MAXIMO);
  const teto = taxa >= 0 ? FADIGA_TETO : Math.max(FADIGA_TETO, snap);
  return clamp(snap + min * taxa, 0, Math.min(teto, FADIGA_MAXIMO));
}

/**
 * A stamina como o jogador vê: 0 a 100%, e acima de 100% com o Pergaminho de Fadiga (sem teto). Abaixo do custo de um
 * décimo (esgotada: sem saque, sem skill) é 0%; com qualquer sobra acima disso, pelo menos 1%.
 */
export function fadigaPct(valor: number): number {
  if (valor < FADIGA_CUSTO_DECIMO) return 0;
  return Math.max(1, Math.floor((clamp(valor, 0, FADIGA_MAXIMO) / FADIGA_TETO) * 100));
}

function clamp(n: number, lo: number, hi: number): number {
  return Math.min(hi, Math.max(lo, n));
}
